<!-- 隐私政策 -->
<template>
  <div class="template-container">
    <div class="box-main">
      <div class="main-title">{{ $t("privacyPolicy.text1") }}</div>
      <div class="main-text">{{ $t("privacyPolicy.text2") }}</div>
      <div class="main-text">{{ $t("privacyPolicy.text3") }}</div>
      <div class="main-name">{{ $t("privacyPolicy.text4") }}</div>
      <div class="main-text">{{ $t("privacyPolicy.text5") }}</div>
      <div class="main-text">{{ $t("privacyPolicy.text6") }}</div>
      <div class="main-name">{{ $t("privacyPolicy.text7") }}</div>
      <div class="main-text">{{ $t("privacyPolicy.text8") }}</div>
      <div class="main-text">{{ $t("privacyPolicy.text9") }}</div>
      <div class="main-text">{{ $t("privacyPolicy.text10") }}</div>
      <div class="main-text">{{ $t("privacyPolicy.text11") }}</div>
      <div class="main-text">{{ $t("privacyPolicy.text12") }}</div>
      <div class="main-name">{{ $t("privacyPolicy.text13") }}</div>
      <div class="main-text">{{ $t("privacyPolicy.text14") }}</div>
      <div class="main-text">{{ $t("privacyPolicy.text15") }}</div>
      <div class="main-text">{{ $t("privacyPolicy.text16") }}</div>
      <div class="main-text">{{ $t("privacyPolicy.text17") }}</div>
      <div class="main-text">{{ $t("privacyPolicy.text18") }}</div>
      <div class="main-text">{{ $t("privacyPolicy.text19") }}</div>
      <div class="main-name">{{ $t("privacyPolicy.text20") }}</div>
      <div class="main-text">{{ $t("privacyPolicy.text21") }}</div>
      <div class="main-text">{{ $t("privacyPolicy.text22") }}</div>
      <div class="main-name">{{ $t("privacyPolicy.text23") }}</div>
      <div class="main-text">{{ $t("privacyPolicy.text24") }}</div>
      <div class="main-name">{{ $t("privacyPolicy.text25") }}</div>
      <div class="main-text">{{ $t("privacyPolicy.text26") }}</div>
      <div class="main-text">{{ $t("privacyPolicy.text27") }}</div>
      <div class="main-text">{{ $t("privacyPolicy.text28") }}</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang='stylus' scoped>
.template-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
  overflow: hidden;
  box-sizing: border-box;
  background: #fff;

  .span:hover {
    color: #069DF9;
  }

  .span {
    cursor: pointer;
    color: #069DF9;
  }

  .box-main {
    width: 1080px;
    background-color: white;
    padding-bottom: 78px;
    margin-bottom: 40px;

    .main-title {
      line-height: 100px;
      width: 100%;
      text-align: center;
      font-size: 40px;
    }

    .main-name {
      font-size: 30px;
      margin-top: 50px;
    }

    .main-text {
      margin: 18px 0px 8px 0px;
      font-size: 16px;
      line-height: 30px;
    }
  }
}

// 移动端
@media all and (min-width: 320px) and (max-width: 768px) {
  .template-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 1920px;
    margin: 0 auto;
    overflow: hidden;
    box-sizing: border-box;
    background: #fff;

    .box-main {
      background: #960723;
      width: 90%;
      background-color: white;
      padding-bottom: 78px;
      margin-bottom: 40px;
      padding: 0px 18px 0px 18px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/about/privacyPolicy.vue